import { render, staticRenderFns } from "./booklist.vue?vue&type=template&id=04bae526"
import script from "./booklist.vue?vue&type=script&lang=js"
export * from "./booklist.vue?vue&type=script&lang=js"
import style0 from "./booklist.vue?vue&type=style&index=0&id=04bae526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports